import React from 'react';

interface StatusBadgeProps {
  label: string;
  textColor: string;
  bgColor: string;
}

export default function StatusBadge({ label, textColor, bgColor }: StatusBadgeProps) {
  return (
    <span className={`px-2 py-1 text-center rounded-[8px] text-sm font-semibold ${textColor} ${bgColor}`}>{label}</span>
  );
}
